module.exports = "/_next/static/videos/03-video-96d6cf2172022f84ec4977e1dba76bff.mp4";